import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

const PetsContext = createContext();

export const usePets = () => {
  const context = useContext(PetsContext);
  if (!context) {
    throw new Error('usePets must be used within PetsProvider');
  }
  return context;
};

export const PetsProvider = ({ children }) => {
  const [pets, setPets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    // Listener em tempo real para o agregado de pets
    const petsAggregateRef = doc(db, 'agregadoPets', 'all');
    
    const unsubscribe = onSnapshot(
      petsAggregateRef,
      (snapshot) => {
        try {
          if (snapshot.exists()) {
            const data = snapshot.data();
            const petsData = data.pets || [];
            setPets(petsData);
          } else {
            // Se o agregado não existe, retornar array vazio (não lançar erro)
            setPets([]);
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
        }
      },
      (error) => {
        // Callback de erro do onSnapshot
        setLoading(false);
      }
    );

    // Cleanup: remover listener quando o componente desmontar
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <PetsContext.Provider value={{ pets, loading }}>
      {children}
    </PetsContext.Provider>
  );
};




